

















































import { Component, Vue, Watch } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import Button from '@components/Button'
import { getAppSpaceConfig, setAppSpaceConfig } from '@/apps/open/services/app'
import { IAppInfo } from '@/apps/open/store/modules/app/types'
import { ElForm } from 'element-ui/types/form'

interface SpaceFormType {
  spaceValue: number,
  file_format_limit: string,
  file_size_limit: string | number
}

interface ConfigParams {
    app_name: string | undefined;
    space_limit: number | undefined;
    file_size_limit: number;
    file_format_limit: string;
}

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Callback extends Vue {
  loading: boolean = false
  spaceMode: number = 0
  totalSpace: number = 0
  spaceForm: SpaceFormType = {
    spaceValue: 10,
    file_format_limit: '',
    file_size_limit: ''
  }
  spaceUnit: string = 'GB'
  unitOption: string[] = ['GB', 'TB']
  canSaveConfig: boolean = true

  $refs!: {
    form: ElForm
  }

  /* @Watch('spaceForm.spaceValue')
  watchSpaceValue (space: number) {
    if (space >= 1024 && this.spaceUnit === 'GB') {
      this.spaceForm.spaceValue = Number((space / 1024).toFixed(2))
      this.spaceUnit = 'TB'
    }
  } */

  get curEnterpriseId () {
    const curEnterprise = this.$store.getters['User/curEnterprise']
    return curEnterprise.id
  }

  get appId () {
    return this.$route.params.id
  }

  get appInfo (): IAppInfo {
    return this.$store.getters['App/appInfo']
  }

  /* get rule () {
    return {
      spaceValue: [
        { validator: this.verifySpace, trigger: ['blur', 'change'] }
      ]
    }
  } */

  mounted () {
    this.getSpaceInfo()
  }

  /* verifySpace (rule: any, value: number, cb: Function) {
    if (this.spaceMode === 1) {
      const spaceByte = this.getSaveSpaceValueByte() || 0
      if (spaceByte > this.totalSpace) {
        const spaceGB = Number((this.totalSpace / Math.pow(1024, 3)).toFixed(2))
        cb(new Error(`不可超过应用总空间大小 (${spaceGB > 1024 ? `${(spaceGB / 1024).toFixed(2)}TB` : `${spaceGB}GB`})`))
      }
    }
    cb()
  } */

  /**
   * receive config information to control select status
   */
  handleAppSpace (appSpace: number) {
    if (appSpace === -1) {
      this.spaceMode = 0
    } else {
      this.spaceMode = 1
      this.spaceForm.spaceValue = Math.floor(appSpace / 1024)
    }
  }

  handleFormatLimit (format: string) {
    if (format === 'unlimited') {
      this.spaceForm.file_format_limit = ''
    } else {
      this.spaceForm.file_format_limit = format
    }
  }

  handleSizeLimit (size: number) {
    if (size === -1) {
      this.spaceForm.file_size_limit = ''
    } else {
      this.spaceForm.file_size_limit = size
    }
  }

  async getSpaceInfo () {
    const res = await getAppSpaceConfig(this.appId)
    if (res.data.result === 'ok') {
      const resData = res.data.data
      // this.totalSpace = res.data.total_app_spaces
      this.handleAppSpace(resData.app_space_limit)
      this.handleFormatLimit(resData.file_format_limit)
      this.handleSizeLimit(resData.file_size_limit)
    }
  }

  getSizeSendTransform (size: number | string, unit: number = 0) {
    if (size === '') {
      return -1
    } else {
      return Number(size) * Math.pow(1024, unit)
    }
  }

  getFormatSendTransform (format: string) {
    if (format === '') {
      format = 'unlimited'
    }
    return format
  }

  getSaveSpaceValueByte (spaceSite: number) {
    switch (this.spaceMode) {
      case 0:
        return -1
      case 1:
        return this.getSizeSendTransform(spaceSite, 1)
    }
  }

  saveSpaceConfig () {
    this.$refs.form.validate().then(async (valid: boolean) => {
      if (valid) {
        const params: ConfigParams = {
          app_name: this.appInfo.app_name,
          space_limit: this.getSaveSpaceValueByte(this.spaceForm.spaceValue),
          file_size_limit: this.getSizeSendTransform(this.spaceForm.file_size_limit, 0),
          file_format_limit: this.getFormatSendTransform(this.spaceForm.file_format_limit)
        }
        try {
          const res = await setAppSpaceConfig(this.appId, params)
          if (res.data.result === 'ok') {
            this.$message.success('设置成功')
          }
        } catch (err) {
          this.$message.error(err.message)
        }
      }
    })
  }

  switchLoading () {
    this.loading = !this.loading
  }
}
